import React from 'react';

import 'core-js';
import {createRoot} from 'react-dom/client';
import 'regenerator-runtime/runtime';
import AppRoot from 'src/app/root.component';

const rootEl = document.getElementById('root');

if (rootEl) {
    createRoot(rootEl).render(<AppRoot/>);
}
